import React from 'react';
import { motion } from 'framer-motion';
import { Loader2Icon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-xl font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#007AFF] text-white hover:bg-[#005FCC] focus:ring-[#007AFF] shadow-md hover:shadow-lg',
    secondary: 'bg-[#E6F2FF] text-[#007AFF] hover:bg-[#CCE5FF] focus:ring-[#007AFF]',
    outline: 'border-2 border-gray-200 text-gray-700 hover:border-[#007AFF] hover:text-[#007AFF] hover:bg-[#F7F8FA] focus:ring-[#007AFF]',
    ghost: 'text-gray-600 hover:text-[#007AFF] hover:bg-[#F7F8FA] focus:ring-[#007AFF]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  return <motion.button whileHover={disabled || isLoading ? {} : {
    scale: 1.02
  }} whileTap={disabled || isLoading ? {} : {
    scale: 0.98
  }} className={classes} disabled={disabled || isLoading} {...props} data-id="element-530">
      {isLoading && <Loader2Icon className="w-5 h-5 mr-2 animate-spin" data-id="element-531" />}
      {children}
    </motion.button>;
}